import ListCourses from "../../components/catalog/ListCourses";
import React from "react";
import {useDispatch} from "react-redux";
import EntityApi from "../../api/EntityApi";
import {useNavigate, useOutletContext, useParams, useSearchParams} from "react-router-dom";
import {resetItems, setTitle} from "../../redux/slices/menuSlice";
import useAuth from "../../hooks/useAuth";
import ModalConfirm from "../../components/main/ModalConfirm";
import UserApi from "../../api/UserApi";
import Button from "../../components/element/Button";
import {Modal, Dropdown, Space, Input, TreeSelect, Select}  from 'antd';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRemove, faEdit, faChevronDown} from "@fortawesome/free-solid-svg-icons";
import { DownOutlined } from '@ant-design/icons';

const CatalogListPage = () => {

    const { setIsLoadingCategories } = useOutletContext();
    const dispatch = useDispatch();
    const { roles } = useAuth();
    const [isRemoveOpen, setIsRemoveOpen] = React.useState(false);
    const [isEditOpen, setIsEditOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isLoadingSave, setIsLoadingSave] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [title, setTitle] = React.useState('');
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [categoriesData, setCategoriesData] = React.useState([{
        key: 0,
        value: 0,
        title: 'Корень каталога'
    }]);

    const [formTitle, setFormTitle] = React.useState('');
    const [formSort, setFormSort] = React.useState('');
    const [formCategoryParent, setFormCategoryParent] = React.useState(0);
    const [isRefresh, setRefresh] = React.useState(false);
    const [sorter, setSorter] = React.useState({isStickerTop: 'desc'});

    React.useEffect(() => {

        setIsLoading(true);

        let filter = {}
        if (id !== undefined && parseInt(id) > 0) {
            filter = {
                category_id: parseInt(id)
            };

            EntityApi.get('private/category', parseInt(id)).then(data => {
                if (data.status === 'success') {
                    setTitle(data.content.item.title);
                    setFormTitle(data.content.item.title);
                    setFormSort(data.content.item.sort);
                    if (data.content.item.parent) {
                        setFormCategoryParent(data.content.item.parent.id);
                    } else {
                        setFormCategoryParent(0);
                    }
                }
            })
        } else if (id !== undefined && id === 'my') {

            setTitle('Мои курсы');
            filter = {
                category_id: 'my'
            };

        } else {
            setTitle('Все курсы');
            let query = searchParams.get('query');
            if (query) {
                filter = {
                    search: query
                };
                setTitle('Поиск по курсам: ' + query);
            }
        }

        EntityApi.getBy('private/product', {
            'filter': filter,
            'sort': sorter
        })
            .then((data) => {
            if (data.status === 'success') {
                let items = [];
                if (data.content.items) {
                    data.content.items.forEach((item) => {
                        items.push({
                            id: item.id,
                            active: item.active,
                            title: item.title,
                            code: item.code,
                            image: item.picture?.url,
                            access: item.access,
                            price: item.price,
                            is_sticker_new: item.is_sticker_new,
                            is_sticker_hit: item.is_sticker_hit,
                        });
                    })
                }
                setItems(items);
                setIsLoading(false);
            }
        })

    }, [id, searchParams, isRefresh]);


    const onSorter = (value) => {
        setSorter({[value]: 'desc'});
        setRefresh(!isRefresh);
    }

    const onRemove = () => {
        setIsRemoveOpen(false);
        if (roles.includes('ROLE_ADMIN') && id !== undefined && parseInt(id) > 0) {
            EntityApi.delete('private/category', parseInt(id)).then(data => {
                setIsLoadingCategories(false);
                navigate('/cabinet/catalog');
            });
        }
    }

    const onSave = () => {
        setIsLoadingSave(true);
        if (roles.includes('ROLE_ADMIN') && id !== undefined && parseInt(id) > 0 && formTitle !== '') {
            EntityApi.post('private/category', parseInt(id), {
                title: formTitle,
                parent: formCategoryParent,
                sort: formSort
            }).then((data) => {
                setIsLoadingSave(false);
                if (data.status === EntityApi.STATUS_SUCCESS) {
                    setIsEditOpen(false);
                    setTitle(formTitle);
                    setIsLoadingCategories(false);
                }
            }).catch(() => {
                setIsLoadingSave(false);
            })
        }
    }

    const h1Styles = {
        /*marginBottom: "16px"*//*marginBottom: "16px"*/
    }

    const eventsDropdown = [
        {
            key: '1',
            label: 'Изменить',
            icon: <FontAwesomeIcon icon={faEdit} />,
            onClick: () => {

                EntityApi.getBy('private/category', {
                    filter: {parent: 0}
                }).then((data) => {
                   if (data.status === EntityApi.STATUS_SUCCESS) {
                       let treeData = [{
                           key: 0,
                           value: 0,
                           title: 'Корень каталога'
                       }];
                       data.content.items.forEach((item) => {
                           let treeDataItem = {
                               key: item.id,
                               value: item.id,
                               title: '. ' + item.title,
                               children: []
                           }
                           if (item.subitems !== undefined) {
                               item.subitems.forEach((subitem) => {
                                   /*treeDataItem.children.push({
                                       key: subitem.id,
                                       value: subitem.id,
                                       title: subitem.title
                                   });*/
                               })
                           }
                           treeData.push(treeDataItem);
                       })
                       setCategoriesData(treeData);
                   }
                })
                setIsEditOpen(true);
            }
        },
        {
            key: '2',
            label: 'Удалить',
            icon: <FontAwesomeIcon icon={faRemove} />,
            onClick: () => setIsRemoveOpen(true),
            danger: true
        }
    ]

    return <>
        <div className={'flex mob-block justify-between items-end pb-6'}>
            <h2 className="text-xl mob-p-4 mob-w-full font-medium text-slate-900 dark:text-navy-50 mr-4 flex w-8/12" style={h1Styles}>
                {title}
                {
                    roles.includes('ROLE_ADMIN') && id !== undefined && parseInt(id) > 0 &&
                    <Dropdown
                        menu={{
                            items: eventsDropdown
                        }}
                        trigger={['click']}
                    >
                        <button className={'popper-ref btn h-8 w-8 rounded-full p-0 ml-2'}>
                            <Space>
                                <FontAwesomeIcon icon={faChevronDown}/>
                            </Space>
                        </button>
                    </Dropdown>
                    /*<div className={"flex text-sm px-4"} style={{fontSize: '9pt'}}>
                        <Button onClick={() => setIsEditOpen(true)} type={'default'} text={<FontAwesomeIcon icon={faEdit} />} />
                        <Button onClick={() => setIsRemoveOpen(true)} type={'errorOutline'} text={<FontAwesomeIcon icon={faRemove} />} />
                    </div>*/
                }
            </h2>
            <div className={'flex items-center'}>
                <span className={'pr-2'}>Сортировка:</span>
                <Select defaultValue="isStickerTop"
                        style={{ width: 200 }}
                        onChange={onSorter}
                        options={[
                            { value: 'isStickerTop', label: 'По умолчанию' },
                            { value: 'id', label: 'По дате создания' },
                            { value: 'dt', label: 'По дате изменения' },
                            { value: 'isStickerNew', label: 'Новинки' },
                            { value: 'isStickerHit', label: 'Хиты продаж' },
                        ]}></Select>
            </div>
        </div>
        <ListCourses isLoading={isLoading} items={items}/>
        <ModalConfirm title={'Удаление раздела'} text={'Вы действительно хотите удалить этот раздел?'}
                      cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={onRemove} isOpen={isRemoveOpen}
                      onClose={() => setIsRemoveOpen(false)}/>
        <Modal
            title="Изменить раздел"
            open={isEditOpen}
            onCancel={() => setIsEditOpen(false)}
            footer={(_, {OkBtn, CancelBtn}) => (
                <div className={'flex'}>
                    <div className={'w-6/12 pr-2'}>
                        <Button text={'Отмена'} onClick={() => setIsEditOpen(false)}/>
                    </div>
                    <div className={'w-6/12'}>
                        <Button text={'Сохранить'} loading={isLoadingSave} onClick={() => onSave()} type={'primary'}/>
                    </div>
                </div>
            )}>
            <div>
                <div className={'w-full'}>
                    <Input value={formTitle} onChange={(evt) => setFormTitle(evt.target.value)}
                           placeholder={'Введите название раздела'}/>
                </div>
                <div className={'w-full mt-2'}>
                    <TreeSelect
                        style={{
                            width: '100%',
                        }} value={formCategoryParent} onChange={(v) => setFormCategoryParent(v)}
                        treeData={categoriesData}></TreeSelect>
                </div>
                <div className={'w-3/12 mt-2'}>
                    <Input value={formSort} onChange={(evt) => setFormSort(evt.target.value)}
                           placeholder={'Сортировка'}/>
                </div>
            </div>
        </Modal>
    </>

}

export default CatalogListPage;
